import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import RouteNames from "./RouteName";
import Skeleton from "./Skeleton";
import Profile from "../components/Profile";

import Login from "../pages/login/Login";
import SignUp from "../pages/signUp/SignUp";
import HomeDashboard from "../pages/HomeDashboard";

import UserAddForm from "../pages/user/add";
import UserList from "../pages/user/list";
import UserEdit from "../pages/user/edit";

import FleetMasterAddForm from "../pages/corporate-admin/fleetmaster/add";
import FleetMasterView from "../pages/corporate-admin/fleetmaster/edit";
import FleetMasterList from "../pages/corporate-admin/fleetmaster/list";

import DriverMasterAddForm from "../pages/corporate-admin/drivermaster/add";
import DriverMasterList from "../pages/corporate-admin/drivermaster/list";
import DriverMasterEdit from "../pages/corporate-admin/drivermaster/edit";

import HelperMasterAddForm from "../pages/corporate-admin/helpermaster/add";
import HelperMasterView from "../pages/corporate-admin/helpermaster/list";
import HelperMasterEdit from "../pages/corporate-admin/helpermaster/edit";

import CustomerMasterAddForm from "../pages/corporate-admin/customermaster/add";
import CustomerMasterView from "../pages/corporate-admin/customermaster/list";
import CustomerMasterEditForm from "../pages/corporate-admin/customermaster/edit";

import VendorMasterAdd from "../pages/corporate-admin/vendormaster/add";
import VendorMasterView from "../pages/corporate-admin/vendormaster/list";
import VendorMasterEdit from "../pages/corporate-admin/vendormaster/edit";

import LaneMasterAdd from "../pages/corporate-admin/lanemaster/add";
import LaneMasterView from "../pages/corporate-admin/lanemaster/list";
import LaneMasterEdit from "../pages/corporate-admin/lanemaster/edit";

import ContractorMasterAdd from "../pages/corporate-admin/contractormaster/add";
import ContractorMasterView from "../pages/corporate-admin/contractormaster/list";
import ContractorMasterEdit from "../pages/corporate-admin/contractormaster/edit";

import LocationMasterAdd from "../pages/corporate-admin/locationmaster/add";
import LocationMasterView from "../pages/corporate-admin/locationmaster/list";
import LocationMasterEdit from "../pages/corporate-admin/locationmaster/edit";

import ContractualTripAdd from "../pages/trip/add";
import ContractualTripEdit from "../pages/trip/edit";
import ContractualTripView from "../pages/trip/list";

import AdhocLaneAdd from "../pages/manager/adhoc/lane/AdhocLaneAdd";
import AdhocLaneView from "../pages/manager/adhoc/lane/AdhocLaneView";
import AdhocLaneEdit from "../pages/manager/adhoc/lane/AdhocLaneEdit";

import AdhocVendorAdd from "../pages/manager/adhoc/vendor/AdhocVendorAdd";
import AdhocVendorView from "../pages/manager/adhoc/vendor/AdhocVendorView";

import AdhocTripView from "../pages/manager/adhoc/trip/AdhocTripView";
import AdhocTripEdit from "../pages/manager/adhoc/trip/AdhocTripEdit";
import AdhocTripCreate from "../pages/manager/adhoc/trip/AdhocTripCreate";

function AppRoutes() {
   return (
      <Routes>
         {/* Common Routes */}
         <Route path="/Login" element={<Login />} />

         {/* Protected Routes */}
         <Route element={<Skeleton />}>
            {/* Home */}
            <Route index path="/" element={<HomeDashboard />} />
            <Route path="dashboard" element={<HomeDashboard />} />

            {/* Profile */}
            <Route path={RouteNames.profileView} element={<Profile />} />
            {/* User Routes */}
            <Route path={RouteNames.userAddForm} element={<UserAddForm />} />
            <Route path={RouteNames.userList} element={<UserList />} />
            <Route path={RouteNames.userEdit} element={<UserEdit />} />

            {/* Fleet Master Routes */}
            <Route
               path={RouteNames.fleetMasterAddForm}
               element={<FleetMasterAddForm />}
            />
            <Route path={RouteNames.fleetMasterView} element={<FleetMasterView />} />
            <Route path={RouteNames.fleetMasterList} element={<FleetMasterList />} />

            {/* Driver Master Routes */}
            <Route
               path={RouteNames.driverMasterAddForm}
               element={<DriverMasterAddForm />}
            />
            <Route path={RouteNames.driverMasterView} element={<DriverMasterList />} />
            <Route path={RouteNames.driverMasterEdit} element={<DriverMasterEdit />} />

            {/* Helper Master Routes */}
            <Route
               path={RouteNames.helperMasterAddForm}
               element={<HelperMasterAddForm />}
            />
            <Route path={RouteNames.helperMasterView} element={<HelperMasterView />} />
            <Route path={RouteNames.helperMasterEdit} element={<HelperMasterEdit />} />

            {/* Customer Master Routes */}
            <Route
               path={RouteNames.customerMasterAddForm}
               element={<CustomerMasterAddForm />}
            />
            <Route
               path={RouteNames.customerMasterView}
               element={<CustomerMasterView />}
            />
            <Route
               path={RouteNames.customerMasterEdit}
               element={<CustomerMasterEditForm />}
            />

            {/* Vendor Master Routes */}
            <Route path={RouteNames.vendorMasterAddForm} element={<VendorMasterAdd />} />
            <Route path={RouteNames.vendorMasterView} element={<VendorMasterView />} />
            <Route path={RouteNames.vendorMasterEdit} element={<VendorMasterEdit />} />

            {/* Lane Master Routes */}
            <Route path={RouteNames.LaneMasterAddForm} element={<LaneMasterAdd />} />
            <Route path={RouteNames.laneMasterView} element={<LaneMasterView />} />
            <Route path={RouteNames.laneMasterEdit} element={<LaneMasterEdit />} />

            {/* Contractor Master Routes */}
            <Route
               path={RouteNames.ContractorMasterAddForm}
               element={<ContractorMasterAdd />}
            />
            <Route
               path={RouteNames.contractorMasterView}
               element={<ContractorMasterView />}
            />
            <Route
               path={RouteNames.contractorMasterEdit}
               element={<ContractorMasterEdit />}
            />

            {/* Location Master Routes */}
            <Route
               path={RouteNames.LocationMasterAddForm}
               element={<LocationMasterAdd />}
            />
            <Route
               path={RouteNames.LocationMasterView}
               element={<LocationMasterView />}
            />
            <Route
               path={RouteNames.LocationMasterEdit}
               element={<LocationMasterEdit />}
            />

            {/* Trip Routes */}
            <Route
               path={RouteNames.contaractualTripAdd}
               element={<ContractualTripAdd />}
            />
            <Route
               path={RouteNames.contractualTripView}
               element={<ContractualTripView />}
            />
            <Route
               path={RouteNames.contractualTripEdit}
               element={<ContractualTripEdit />}
            />

            <Route path={RouteNames.adhocTripAdd} element={<AdhocTripCreate />} />
            <Route path={RouteNames.adhocTripView} element={<AdhocTripView />} />
            <Route path={RouteNames.adhocTripEdit} element={<AdhocTripEdit />} />
            {/* <Route path={RouteNames.managerVendorView} element={<ViewTrip />} /> */}

            {/* Manager Adhoc Routes */}
            <Route path={RouteNames.adhocLaneAdd} element={<AdhocLaneAdd />} />
            <Route path={RouteNames.adhocLaneView} element={<AdhocLaneView />} />
            <Route path={RouteNames.adhocLaneEdit} element={<AdhocLaneEdit />} />
            <Route path={RouteNames.adhocVendorAdd} element={<AdhocVendorAdd />} />
            <Route path={RouteNames.adhocVendorView} element={<AdhocVendorView />} />
         </Route>
      </Routes>
   );
}

export default AppRoutes;



